import type { Permission as PermissionModel } from '@/adapters/catalogv1.g';

/**
 * Transform a backend Permission model to a frontend CatalogPermission type.
 * @param model - API Permission response from catalog
 * @returns CatalogPermission - UI-friendly Permission object
 */
export function extractPermission(model: PermissionModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.permission_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogPermission = ReturnType<typeof extractPermission>;
